import React, { useState } from 'react';

// "Vigtigt at vide" — folded by default inside a hero card. Drop inside
// any .detail-hero when a page needs a deeper explanation
// that shouldn't sit in the always-visible hero paragraph.
export default function MoreInfo({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" className={`more-toggle ${open ? 'open' : ''}`} onClick={() => setOpen((o) => !o)}>
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
          <path d="M9 6l6 6-6 6" />
        </svg>
        Vigtigt at vide
      </button>
      <div className={`more-content ${open ? 'open' : ''}`}>{children}</div>
    </>
  );
}
